<template>
  <div class='Box'>
    <el-card class="box-card">
      <el-form :model="queryParams" size="medium" label-width="100px" class="mt35">
        <el-row :gutter="35" style="display: flex;flex-wrap: wrap;">
          <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
            <el-form-item label="合同ID">
              <el-input v-model="queryParams.id" @change="search" @clear="search" placeholder="请输入合同ID"
                        clearable></el-input>
            </el-form-item>
          </el-col>

          <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
            <el-form-item label="合同编号">
              <el-input v-model="queryParams.code" @change="search" @clear="search" placeholder="请输入合同编号"
                        clearable></el-input>
            </el-form-item>
          </el-col>

          <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
            <el-form-item label="合同名称">
              <el-input v-model="queryParams.name" @change="search" @clear="search" placeholder="请输入合同名称"
                        clearable></el-input>
            </el-form-item>
          </el-col>

          <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
            <el-form-item label="甲方主体公司">
              <SelectChecked :options="subjectListA" :isRemoveAllTag="isRemoveAllTag" placeholder="请选择甲方主体公司"
                             @selectedVal="selectedA" :search="search"/>
            </el-form-item>
          </el-col>

          <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
            <el-form-item label="乙方主体公司">
              <SelectChecked :options="subjectListB" :isRemoveAllTag="isRemoveAllTag" placeholder="请选择乙方主体公司"
                             @selectedVal="selectedB" :search="search"/>
            </el-form-item>
          </el-col>

          <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
            <el-form-item label="合同类型">
              <el-select v-model="queryParams.type" filterable @change="search" @clear="search" placeholder="请选择合同类型"
                         style="width: 100%;" clearable>
                <el-option v-for="(dict,i) in typeOptions" :key="i" :label="dict.label"
                           :value="dict.value"/>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
            <el-form-item label="状态">
              <el-select v-model="queryParams.status" placeholder="请选择状态" @change="search" clearable style="width: 100%;">
                <el-option label="正常" :value="1"></el-option>
                <el-option label="禁用" :value="0"></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
            <div class="btn_left">
              <el-button type="primary" size="medium" @click="search">查询</el-button>
              <el-button @click="addNoNe" size="medium">重置</el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>
      <div class="div_buttom">
        <el-button size="medium" @click="refresh">刷新列表</el-button>
        <el-button size="medium" type="primary" icon="el-icon-plus" @click="addList">添加</el-button>
      </div>
      <el-table ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%"
                size="medium"
                :header-cell-style="{textAlign:'center',background:'#f5f7fa'}" :cell-style="{textAlign:'center'}"
                @selection-change="handleSelectionChange" border v-loading="loading">
        <el-table-column label="ID" width="80">
          <template slot-scope="scope">{{ scope.row.id }}</template>
        </el-table-column>

        <el-table-column label="合同编号">
          <template slot-scope="scope">{{ scope.row.code }}</template>
        </el-table-column>

        <el-table-column prop="name" label="合同名称">
          <template slot-scope="scope">{{ scope.row.name }}</template>
        </el-table-column>

        <el-table-column prop="a_subject_text" label="甲方主体公司">
          <template slot-scope="scope">
            <div class="subjectBox" v-for="(item, index) in scope.row.a_subject_text" :key="index">
              <span>{{ item }}</span>
            </div>
          </template>
        </el-table-column>

        <el-table-column prop="b_subject_text" label="乙方主体公司">
          <template slot-scope="scope">
            <div class="subjectBox" v-for="(item, index) in scope.row.b_subject_text" :key="index">
              <span>{{ item }}</span>
            </div>
          </template>
        </el-table-column>

        <el-table-column prop="name" label="合同类型" width="80">
          <template slot-scope="scope">{{ getTypeText(scope.row.type) || '-' }}</template>
        </el-table-column>

        <el-table-column prop="name" label="有效期">
          <template slot-scope="scope">{{ formatDate(scope.row.validity_start) }} 至 {{ formatDate(scope.row.validity_end) }}</template>
        </el-table-column>

        <el-table-column prop="name" label="状态" width="80">
          <template slot-scope="scope">
            <el-tag type="success" v-if="scope.row.status == 1">正常</el-tag>
            <el-tag type="danger" v-else>禁用</el-tag>
          </template>
        </el-table-column>

        <el-table-column fixed="right" label="操作" width="80">
          <template slot-scope="scope">
            <el-button type="text" size="medium" @click="addEdit(scope.row)">编辑</el-button>
          </template>
        </el-table-column>

      </el-table>
      <pagination v-show="total > 0" :total="total" :page.sync="queryParams.pageNo"
                  :limit.sync="queryParams.pageSize" @pagination="getList('changePage')"/>
      <ContractEdit :AddContractFlag="AddContractFlag" @NoneDlog="NoneDlog" @AddOk="AddOk"
                    :editID="editID" :typeOptions="typeOptions">
      </ContractEdit>
    </el-card>
  </div>
</template>

<script>
import {MoneyManagementAPI} from '@/api/MoneyManagement/MoneyManagement';
import {processErrors} from "@/utils/errorHandler";
import ContractEdit from "./edit.vue"
import SelectChecked from '@/components/Select/SelectChecked.vue';

export default {
  components: {
    ContractEdit,
    SelectChecked
  },
  data() {
    return {
      form: {
        name: ""
      },
      SearchFlag: false,
      queryParams: {
        pageNo: 1,
        pageSize: 10,
        a_subject_id: "",
        b_subject_id: "",
        type:'',
        id:'',
        code:''
      },
      appidList: [],
      page: {
        pageNo: 1,
        pageSize: 999,
      },

      tableData: [],
      multipleSelection: [],
      dialogVisible: false,
      editID: "",
      // 总条数
      total: 0,
      AddContractFlag: false,
      loading: false,
      subjectListA: [],
      subjectListB: [],
      isRemoveAllTag: 0,
      typeOptions: [
        {value: 1, label: '收剧'},
        {value: 2, label: '出剧'},
        {value: 3, label: '置换'},
        {value: 4, label: '剧本'},
        {value: 5, label: '承制'},
        {value: 6, label: '资方引入'},
        {value: 7, label: '联合发行'},
        {value: 8, label: '分销'},
        {value: 9, label: '其他'}
      ],
    };
  },
  created() {
    this.getSubjectSelect()
    this.getList()
  },
  methods: {

    formatDate(dateString) {
      const date = new Date(dateString);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0'); // 月份从 0 开始
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },

    getSubjectSelect() {
      let api = MoneyManagementAPI()
      api.getSubjectSelect().then(res => {
        if (res.code == 0) {
          let list = JSON.parse(JSON.stringify(res.data))
          list.map(item=>{
            item.label = item.name
            item.value = item.id
            item.check = false
          })
          this.subjectListA = JSON.parse(JSON.stringify(list))
          this.subjectListB = JSON.parse(JSON.stringify(list))
        } else {
          processErrors(res);
        }
      })
    },

    getList(type) {
      this.loading = true
      if(type != 'changePage'){
        this.queryParams.pageNo = 1
      }
      let api = MoneyManagementAPI()
      api.getContractList(this.queryParams).then(res => {
        if (res.code == 0) {
          res.data.data.forEach((item)=>{
            if(item.a_subject_text){
              item.a_subject_text = item.a_subject_text.split(',')
            }
            if(item.b_subject_text){
              item.b_subject_text = item.b_subject_text.split(',')
            }
          })
          this.tableData = res.data.data
          this.total = res.data.totalCount
        } else {
          processErrors(res);
        }
        this.loading = false
      })
    },

    addSearch() {
      if (this.SearchFlag == false) {
        this.SearchFlag = true
      } else {
        this.SearchFlag = false
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    search() {
      this.getList()
    },
    addNoNe() {
      this.queryParams = {
        pageNo: 1,
        pageSize: 10,
        a_subject_id: "",
        b_subject_id: "",
        type:'',
        id:'',
        code:''
      }
      this.isRemoveAllTag += 1;
      this.getList()
    },
    addList() {
      this.editID = ""
      this.AddContractFlag = true
    },
    NoneDlog() {
      this.AddContractFlag = false
    },
    AddOk() {
      this.getList(this.editID != '' ? 'changePage' : '')
      this.editID = ""
      this.AddContractFlag = false
    },
    addEdit(row) {
      this.editID = row.id
      this.AddContractFlag = true
    },
    selectedA(value){
      this.queryParams.a_subject_id = value.join(',');
    },
    selectedB(value){
      this.queryParams.b_subject_id = value.join(',');
    },
    getTypeText(type){
      const item = this.typeOptions.filter(item => item.value === type)[0]
      return item.label
    },
    refresh(){
      this.getList('changePage')
      this.getSubjectSelect()
    }
  },

  mounted() {

  },
}
</script>
<style lang='scss' scoped>
.Box {
  & ::v-deep el-card__body {

    padding: 0 !important;

  }
}

.el-card__body {
  padding: 0px !important;
}

.btn_left {
  margin-left: 100px;
}

.div_buttom {
  width: 100%;
  display: flex;
  margin-bottom: 20px;
}
.subjectBox{
  display: flex;
  align-items: center;
  // justify-content: flex-start;
  .circle{
    display: block;
    width: 8px;
    height: 8px;
    background: red;
    border-radius: 50%;
  }
}
</style>